import React, { useState } from 'react';
import Context from '../../../context';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { Button, Typography, TextField, Grid } from '@material-ui/core';
import { Add, Cancel, Block, Save, Delete } from '@material-ui/icons';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import {
  updateContentMultiImg,
  postContentMultiImg,
  getContent,
  deleteDataImgContent,
} from '../../../services';

const title = 'Banner';
const type = 11;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',

      '& > *': {
        margin: theme.spacing(1),
        maxWidth: '1000px',
      },
    },
    rootRadio: {
      marginTop: '.5rem',
    },
  })
);

const FormCrudBanner = ({ onCancel, action, type, title, data }: any) => {
  const context = React.useContext(Context);
  const isAdd = action === 'Add' ? true : false;
  const initForm = {
    id: '',
    image: '',
    imageRead: '',
    imageEn: '',
    imageReadEn: '',
    title_id: '',
    title_en: '',
  };
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState(isAdd ? initForm : data);
  const { id, image, imageRead, imageEn, imageReadEn, title_id, title_en } =
    formState;

  const handleChange = (event: any) => {
    setFormState({ ...formState, [event.target.name]: event.target.value });
  };

  const handleImageChange = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setFormState({
        ...formState,
        image: event.target.files[0],
        imageRead: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleImageChangeEn = (event: any) => {
    if (event.target.files && event.target.files[0]) {
      setFormState({
        ...formState,
        imageEn: event.target.files[0],
        imageReadEn: URL.createObjectURL(event.target.files[0]),
      });
    }
  };

  const handleAddCrudBanner = async (e: any) => {
    e.preventDefault();
    if (image.size > 5000000 || imageEn.size > 5000000) {
      enqueueSnackbar('Maximum photo size 5mb', {
        variant: 'error',
      });
      return;
    }
    if (!imageEn.name.includes('_en')) {
      enqueueSnackbar("IMAGE EN filename must be includes '_en'", {
        variant: 'error',
      });
      return;
    }
    if (image.name.includes('_en')) {
      enqueueSnackbar("IMAGE ID filename must not include '_en'", {
        variant: 'error',
      });
      return;
    }

    const body = new FormData();
    body.append('image', image);
    body.append('image', imageEn);
    body.append('title_id', title_id);
    body.append('title_en', title_en);
    body.append('type', type);

    try {
      const res = await postContentMultiImg(body);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, {
          variant: 'error',
        });
        return;
      }
      enqueueSnackbar(`Berhasil menambahkan data ${title}`, {
        variant: 'success',
      });
      onCancel();
    } catch (err: string | any) {
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  const handleEditCrudBanner = async (e: any) => {
    e.preventDefault();
    if (image?.size > 5000000 || imageEn?.size > 5000000) {
      enqueueSnackbar('Maximum photo size 5mb', {
        variant: 'error',
      });
      return;
    }
    if (imageEn && !imageEn.name.includes('_en')) {
      enqueueSnackbar("IMAGE EN filename must be includes '_en'", {
        variant: 'error',
      });
      return;
    }
    if (image && image.name.includes('_en')) {
      enqueueSnackbar("IMAGE ID filename must not include '_en'", {
        variant: 'error',
      });
      return;
    }
    const body = new FormData();
    body.append('image', image);
    body.append('image', imageEn);
    body.append('title_id', title_id);
    body.append('title_en', title_en);
    body.append('old_image', data.content_id);
    body.append('old_image_en', data.content_en);

    try {
      const res = await updateContentMultiImg(data?.id, body);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, {
          variant: 'error',
        });
        return;
      }
      enqueueSnackbar(`Berhasil merubah data ${title_id}`, {
        variant: 'success',
      });
      onCancel();
    } catch (err: string | any) {
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  const handleDeleteCrudBanner = () => {
    try {
      context.openDialog(
        'Hapus Data',
        `Apakah anda yakin ingin menghapus data ${title_id} ?`,
        async () => {
          const res = await deleteDataImgContent(id, {
            tbl: 'tbl_content',
            image: data.content_id,
            image_en: data.content_en,
          });
          if (res.status === 'error') {
            enqueueSnackbar(res.message, {
              variant: 'error',
            });
            return;
          }
          context.closeDialog();
          enqueueSnackbar(`Berhasil menghapus data  ${title_id}`, {
            variant: 'success',
          });
          onCancel();
        }
      );
    } catch (err: string | any) {
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  return (
    <form
      onSubmit={isAdd ? handleAddCrudBanner : handleEditCrudBanner}
      className={classes.root}
      noValidate
      autoComplete='off'
    >
      <Typography color='primary' variant='h4' style={{ marginBottom: '2rem' }}>
        {isAdd ? 'Add' : 'Edit'} Data {title}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Button variant='outlined' color='primary' component='label'>
            Upload Image ID
            <input type='file' onChange={handleImageChange} hidden />
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button variant='outlined' color='primary' component='label'>
            Upload Image EN
            <input type='file' onChange={handleImageChangeEn} hidden />
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Typography color='textPrimary' style={{ marginBottom: '0.5rem' }}>
            * Max size 5mb
          </Typography>
          {imageRead || data?.content_id ? (
            <img
              style={{ height: '100px' }}
              src={
                imageRead ||
                `${process.env.REACT_APP_URL}/images/${data.content_id}`
              }
              alt='Not Found!'
            ></img>
          ) : (
            <div
              style={{
                textAlign: 'center',
                backgroundColor: '#ededed',
                padding: '1rem',
                borderRadius: '4px',
                width: '200px',
              }}
            >
              <Block />
              <Typography color='textSecondary'>
                Photo does not exist
              </Typography>
            </div>
          )}
        </Grid>
        <Grid item xs={6}>
          <Typography color='textPrimary' style={{ marginBottom: '0.5rem' }}>
            * Max size 5mb
          </Typography>
          <Typography color='textPrimary'>
            * IMAGE EN filename must be includes '_en'
          </Typography>
          <Typography
            color='textPrimary'
            style={{ marginLeft: 10, marginBottom: '0.5rem' }}
          >
            ex. gambar.jpg to gambar_en.jpg
          </Typography>
          {imageReadEn || data?.content_en ? (
            <img
              style={{ height: '100px' }}
              src={
                imageReadEn ||
                `${process.env.REACT_APP_URL}/images/${data.content_en}`
              }
              alt='Not Found!'
            ></img>
          ) : (
            <div
              style={{
                textAlign: 'center',
                backgroundColor: '#ededed',
                padding: '1rem',
                borderRadius: '4px',
                width: '200px',
              }}
            >
              <Block />
              <Typography color='textSecondary'>
                Photo does not exist
              </Typography>
            </div>
          )}
        </Grid>
        <Grid item xs={6}>
          <TextField
            onChange={handleChange}
            value={title_id}
            name='title_id'
            label='Title ID'
            variant='outlined'
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            onChange={handleChange}
            value={title_en}
            name='title_en'
            label='Title EN'
            variant='outlined'
            fullWidth
            required
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div>
            <Button
              variant='outlined'
              color='primary'
              size='large'
              startIcon={<Cancel />}
              style={{ marginRight: '1rem' }}
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<Save />}
              type='submit'
            >
              Save
            </Button>
          </div>
          {!isAdd && (
            <Button
              variant='outlined'
              color='primary'
              size='large'
              startIcon={<Delete />}
              onClick={handleDeleteCrudBanner}
            >
              Delete
            </Button>
          )}
        </Grid>
      </Grid>
    </form>
  );
};

const CrudBanner = () => {
  const initAddState = { open: false, action: 'Add' };
  const [actionState, setActionState] = useState(initAddState);
  const [editState, setEditState] = useState<any>(null);
  return (
    <>
      {actionState.open ? (
        <FormCrudBanner
          title={title}
          type={type}
          action={actionState.action}
          onCancel={() => setActionState(initAddState)}
          data={editState}
        />
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '1rem',
            }}
          >
            <Button
              variant='contained'
              color='primary'
              size='large'
              onClick={() => {
                setEditState(null);
                setActionState({ open: true, action: 'Add' });
              }}
              startIcon={<Add />}
            >
              Add
            </Button>
          </div>
          <MaterialTable
            columns={[
              { title: 'Title ID', field: 'title_id' },
              { title: 'Title EN', field: 'title_en' },
              {
                title: 'Banner ID',
                field: 'content_id',
                render: (rowData) => (
                  <img
                    src={`${process.env.REACT_APP_URL}/images/${rowData.content_id}`}
                    alt={rowData.content_id}
                    width={30}
                  />
                ),
              },
              {
                title: 'Banner EN',
                field: 'content_en',
                render: (rowData) => (
                  <img
                    src={`${process.env.REACT_APP_URL}/images/${rowData.content_en}`}
                    alt={rowData.content_en}
                    width={30}
                  />
                ),
              },
              {
                title: 'Created',
                field: 'created_at',
                align: 'right',
                render: (rowData) =>
                  moment(rowData.created_at).format('YYYY-MM-DD HH:mm'),
              },
            ]}
            title={
              <Typography
                variant='h6'
                color='primary'
                style={{ fontWeight: 600 }}
              >
                List {title}
              </Typography>
            }
            data={(query) =>
              new Promise((resolve) => {
                const { pageSize, page, search } = query;
                getContent(type, pageSize, page + 1, search).then(
                  (result: any) => {
                    resolve({
                      data: result.data.rows,
                      page: Number(result.data.page - 1),
                      totalCount: Number(result.data.total),
                    });
                  }
                );
              })
            }
            onRowClick={(event, rowData) => {
              setEditState(rowData);
              setActionState({ open: true, action: 'Edit' });
            }}
          />
        </>
      )}
    </>
  );
};

export default CrudBanner;
